export function AnnouncementSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/announcement.svg'"></ng-include>`
    }
}